import { IGlobalSearchResult } from '@app/models/GlobalSearchResult'
import classNames from 'classnames'
import * as React from 'react'
import DevelopmentSiteResultItem from '../containers/DevelopmentSiteResultItemContainer'
import { BrokeragePipelineResultItem } from './BrokeragePipelineResultItem'
import { ConnectionResultItem } from './ConnectionResultItem'
import { DevelopmentClientResultItem } from './DevelopmentClientResultItem'
import { FeedItemResultItem } from './FeedItemResultItem'
import { ListingResultItem } from './ListingResultItem'
import { PropertyResultItem } from './PropertyResultItem'
import { SearchResultSet } from './SearchResultSet'

export interface ISearchResultProps {
  inlineResults?: boolean
  results: IGlobalSearchResult
  searchFilter: string
}

export class SearchResults extends React.PureComponent<ISearchResultProps> {
  public render() {
    if (!this.props.results.success) {
      return null
    }

    return this.props.results.totalResults === 0
      ? this._renderNoResults()
      : this._renderResultSets()
  }

  private _renderNoResults() {
    const resultClasses = classNames('global-search-results', {
      'inline-results': this.props.inlineResults === true,
    })

    return (
      <div className={resultClasses}>
        <ul className='result-list'>
          <li className='result-item'>
            <div>No results found</div>
          </li>
        </ul>
      </div>
    )
  }

  private _renderResultSets() {
    const resultClasses = classNames('global-search-results', {
      'inline-results': this.props.inlineResults === true,
    })

    return (
      <div className={resultClasses}>
        <SearchResultSet
          title='Connections'
          itemComponent={ConnectionResultItem}
          items={this.props.results.contacts}
          moreLink={`/connections?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
        <SearchResultSet
          title='Properties'
          itemComponent={PropertyResultItem}
          items={this.props.results.properties}
          moreLink={`/properties/properties/?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
        <SearchResultSet
          title='Development Clients'
          itemComponent={DevelopmentClientResultItem}
          items={this.props.results.clients}
          moreLink={`/development/clients?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
        <SearchResultSet
          title='Development Sites'
          itemComponent={DevelopmentSiteResultItem}
          items={this.props.results.sites}
        />
        <SearchResultSet
          title='Leads'
          itemComponent={FeedItemResultItem}
          items={this.props.results.leads}
          moreLink={`/brokerage/leads?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
        <SearchResultSet
          title='Feed Items'
          itemComponent={FeedItemResultItem}
          items={this.props.results.feedItems}
          moreLink={`/feed/search?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
        {/* <SearchResultSet
          title='Teams'
          itemComponent={TeamResultItem}
          items={this.props.results.teams} /> */}
        <SearchResultSet
          title='Listings'
          itemComponent={ListingResultItem}
          items={this.props.results.listings}
          moreLink={`/brokerage/listings?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
        <SearchResultSet
          title='Brokerage Pipelines'
          itemComponent={BrokeragePipelineResultItem}
          items={this.props.results.brokeragePipelines}
          moreLink={`/brokerage/pipeline?filter=${encodeURIComponent(
            this.props.searchFilter,
          )}`}
        />
      </div>
    )
  }
}
